import { useEffect, useState } from "react";
import { Instagram } from "lucide-react";
import api from "@/lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/gallery").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
        <div>
          <p className="eyebrow text-[#e0481f] text-sm mb-2">The Gallery</p>
          <h1 className="headline text-5xl sm:text-6xl text-[#f7f3ec]">Trail Memories</h1>
        </div>
        <a href="https://instagram.com/i65_ryders" target="_blank" rel="noreferrer" className="btn-gold rounded-full px-5 py-2.5 font-display uppercase tracking-wide text-sm inline-flex items-center gap-2 w-fit" data-testid="gallery-instagram">
          <Instagram size={18} /> @i65_ryders
        </a>
      </div>
      <div className="columns-2 sm:columns-3 lg:columns-4 gap-3 sm:gap-4 space-y-3 sm:space-y-4">
        {items.map((g) => (
          <div key={g.id} className="relative rounded-2xl overflow-hidden break-inside-avoid group" data-testid={`gallery-item-${g.id}`}>
            {(g.is_video || g.type === "video")
              ? <video src={g.media_url} className="w-full object-cover" controls playsInline preload="metadata" />
              : <img src={g.media_url} alt={g.caption} className="w-full object-cover group-hover:scale-105 transition-transform duration-500" />}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4 pointer-events-none">
              <p className="text-[#f7f3ec] text-sm">{g.caption}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
